import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ScreeningSettingState} from './screening-settings.reducer';

export const selectScreeningSettingState = createFeatureSelector<ScreeningSettingState>('screeningSetting');

export const selectSettingByProjectId = (projectId: number) =>
  createSelector(selectScreeningSettingState, (state) => state.settingByProject[projectId] || undefined);

export const selectHasSettingByProjectId = (projectId: number) =>
  createSelector(selectScreeningSettingState, (state) => state.hasSettingByProject[projectId] || false);

export const selectLoadingByProjectId = (projectId: number) =>
  createSelector(selectScreeningSettingState, (state) => state.loadingByProject[projectId] || false);

export const selectErrorByProjectId = (projectId: number) =>
  createSelector(selectScreeningSettingState, (state) => state.errorByProject[projectId] || null);


export const selectQueriesByProjectId = (projectId: number, queryIds: number[]) =>
  createSelector(
    selectSettingByProjectId(projectId),
    (setting) => (setting?.researchDBSettings || []).filter(q => queryIds.includes(q.id)) || []);

export const selectQueryByProjectId = (projectId: number, queryIds: number) =>
  createSelector(
    selectSettingByProjectId(projectId),
    (setting) => (setting?.researchDBSettings || []).filter(q => queryIds === q.id).shift() || null);
